import { ChangeDetectionStrategy, Component, Input, forwardRef } from "@angular/core";
import { identity } from "rxjs";
import { CfMap, CustomFieldTargetType, ICustomField } from "@webapp/custom-fields/models/custom-fields.models";
import { FormItemBaseComponent } from "../form-item-base.component";

@Component({
  selector: "custom-fields-form-item",
  templateUrl: "./custom-fields-form-item.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: FormItemBaseComponent, useExisting: forwardRef(() => CustomFieldsFormItemComponent) }],
})
export class CustomFieldsFormItemComponent extends FormItemBaseComponent<CfMap> {
  @Input() public filter: (customFields: ICustomField[]) => ICustomField[] = identity;
  @Input() public target: CustomFieldTargetType;

  public handleCustomFieldsRequiredChange(change: { areFilled: boolean }): void {
    const error = change.areFilled ? null : { required: true };

    // sets the initial validity state before the first value change
    this.formControl?.setErrors(error);

    // sets the validity state for when value change is emitted (manually set errors get cleared without a validator on value change)
    this.formControl?.setValidators(() => error);
  }
}
